<template>
  <div>
    <div class="mb-2 flex justify-end">
      <div
          class="d-flex smallGap text-secondaryColor align-items-center"
          role="button"
          @click="$router.go(-1)"
      >
        <mdicon :width="25" :height="25" name="arrow-left-thick"/>
        <p class="mb-0" v-text="$t(locale.back)"/>
      </div>
    </div>
    <b-card>
      <div class="d-flex justify-content-between align-items-center">
        <b-card-title class="mb-0">
          {{ $t(locale.createSegment) }}
        </b-card-title>
        <!-- <LittleTabs :tabs="tabs" :switchTabs="switchTabs" /> -->
      </div>
    </b-card>
    <!-- <ValidationObserver ref="form">
        <KeepAlive>
            <transition name="zoom-fade" mode="out-in">
                <component :is="currentComponent" />
            </transition>
        </KeepAlive>
    </ValidationObserver> -->

    <ValidationObserver ref="segmentForm">
      <div v-show="tabSwitch === 1">
        <b-row>
          <b-col cols="12" lg="12">
            <SecondaryCard :title="$t(locale.details)">
              <b-container fluid>
                <b-row>
                  <b-col cols="12" lg="8">
                    <b-row>
                      <b-col cols="12" lg="4">
                        <validation-provider
                            #default="{errors}"
                            :rules="'required'"
                            :name="$t(locale.name)"
                        >
                          <b-form-group
                              :label="$t(locale.name)"
                              label-for="input-1"
                          >
                            <b-form-input
                                size="sm"
                                v-model="singleSegment.name"
                                :placeholder="$t(locale.name)"
                            />
                            <small
                                class="text-danger"
                                v-text="errors[0]"
                            />
                          </b-form-group>
                        </validation-provider>
                      </b-col>

                      <b-col cols="12" lg="4">
                        <validation-provider
                            #default="{errors}"
                            :rules="'required'"
                            :name="$t(locale.description)"
                        >
                          <b-form-group
                              :label="$t(locale.description)"
                              label-for="input-1"
                          >
                            <b-form-input
                                size="sm"
                                v-model="singleSegment.description"
                                :placeholder="$t(locale.description)"
                            />
                            <small
                                class="text-danger"
                                v-text="errors[0]"
                            />
                          </b-form-group>
                        </validation-provider>
                      </b-col>

                      <!-- <b-col cols="12" lg="4">
                          <b-form-group
                                  :label="$t(locale.averageMonthly)"
                                  label-for="input-1"
                              >
                              <b-form-input
                                  size="sm"
                                  v-model="singleSegment.average_monthly_earnings"
                                  type="number"
                                  min="0"
                                  :placeholder="$t(locale.averageMonthly)"
                              />
                          </b-form-group>
                      </b-col> -->

                      <b-col cols="12" lg="4">
                        <b-form-group
                            :label="$t(locale.manufacturer)"
                            label-for="input-1"
                        >
                          <b-form-input
                              size="sm"
                              v-model="singleSegment.manufacturer"
                              :placeholder="$t(locale.manufacturer)"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" lg="4">
                        <b-form-group
                            :label="$t(locale.supplier)"
                            label-for="input-1"
                        >
                          <v-select
                              :placeholder="$t(locale.supplier)"
                              :options="suppliers"
                              v-model="singleSegment.supplier"
                              @option:selected="computeSelect($event, 'supplier')"
                              class="resource-selector select-size-sm d-inline-block w-full"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" lg="4">
                        <b-form-group
                            :label="$t(locale.inventoryLocation)"
                            label-for="input-1"
                        >
                          <b-form-input
                              size="sm"
                              v-model="singleSegment.inventory_location"
                              :placeholder="$t(locale.inventoryLocation)"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" lg="4">
                        <b-form-group
                            :label="$t(locale.unit)"
                            label-for="input-1"
                        >
                          <v-select
                              :placeholder="$t(locale.unit)"
                              :options="units"
                              @option:selected="computeSelect($event, 'unit')"
                              class="resource-selector select-size-sm d-inline-block w-full"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" lg="4">
                        <b-form-group
                            :label="$t(locale.purchaseAccount)"
                            label-for="input-1"
                        >
                          <v-select class="w-full select-size-sm" v-model="singleSegment.purchase_account"
                                    label="number" @option:selected="changeAccounts($event, 'purchase_account')"
                                    :filterable="false" :options="accountResults" @search="searchAccounts">
                            <template slot="no-options">
                              Sök...
                            </template>
                            <template slot="option" slot-scope="option">
                              <div class="d-center">
                                {{ option.number }}
                              </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center">
                                {{ option.number }}
                              </div>
                            </template>
                          </v-select>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" lg="4">
                        <div class="w-full">
                          <b-form-group
                              :label="$t(locale.notes)"
                              label-for="input-1"
                          >
                            <b-form-textarea
                                v-model="singleSegment.notes"
                                :placeholder="$t(locale.notes)"
                            />
                          </b-form-group>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col cols="12" lg="4">
                    <b-row>
                      <b-col cols="12" lg="6">
                        <b-form-group
                            :label="$t(locale.stockItem)"
                            label-for="input-1"
                        >
                          <LittleTabs
                              :tabs="[
                                                        {
                                                            label: 'CustomersCardEdit.yes',
                                                            active: true,
                                                            value: true,
                                                        },
                                                        {
                                                            label: 'CustomersCardEdit.no',
                                                            active: false,
                                                            value: false,
                                                        },
                                                    ]"
                              v-model="singleSegment.stock_item"
                              :defaultValue="true"
                              buttonSize="sm"
                              containerStyle="justify-content-start"
                              btnClass="tabWrapperSmall2"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" lg="6">
                        <b-form-group
                            :label="$t(locale.discontinue)"
                            label-for="input-1"
                        >
                          <LittleTabs
                              :tabs="[
                                                        {
                                                            label: 'CustomersCardEdit.yes',
                                                            active: true,
                                                            value: true,
                                                        },
                                                        {
                                                            label: 'CustomersCardEdit.no',
                                                            active: false,
                                                            value: false,
                                                        },
                                                    ]"
                              v-model="singleSegment.discontinued"
                              :defaultValue="true"
                              buttonSize="sm"
                              containerStyle="justify-content-start"
                              btnClass="tabWrapperSmall2"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" lg="6">
                        <b-form-group
                            :label="$t(locale.externalWebshop)"
                            label-for="input-1"
                        >
                          <LittleTabs
                              :tabs="[
                                                        {
                                                            label: 'CustomersCardEdit.yes',
                                                            active: true,
                                                            value: true,
                                                        },
                                                        {
                                                            label: 'CustomersCardEdit.no',
                                                            active: false,
                                                            value: false,
                                                        },
                                                    ]"
                              v-model="singleSegment.external_webshop"
                              :defaultValue="true"
                              buttonSize="sm"
                              containerStyle="justify-content-start"
                              btnClass="tabWrapperSmall2"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" lg="6">
                        <b-form-group
                            :label="$t(locale.productType)"
                            label-for="input-1"
                        >
                          <LittleTabs
                              :tabs="[
                                                        {
                                                            label: 'ArticleSegment.form.stock',
                                                            active: true,
                                                            value: 'STOCK',
                                                        },
                                                        {
                                                            label: 'ArticleSegment.form.service',
                                                            active: false,
                                                            value: 'SERVICE',
                                                        },
                                                    ]"
                              v-model="singleSegment.product_type"
                              :defaultValue="true"
                              buttonSize="sm"
                              containerStyle="justify-content-start"
                              btnClass="tabWrapperSmall2"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-container>
            </SecondaryCard>
          </b-col>

        </b-row>
      </div>

      <b-col cols="12">
        <b-row align-h="between" class="smallGap mt-1">
          <b-col cols="12" lg="3">

          </b-col>
          <b-col
              cols="12"
              lg="4"
              class="d-flex justify-content-between justify-lg-end"
          >
            <div class="">
              <b-button
                  block
                  variant="outline-danger"
                  @click="$router.go(-1)"
                  v-text="$t(locale.cancel)"
              />
            </div>
            <div class="">
              <b-button
                  @click="createArticleSegment"
                  block
                  variant="primary"
                  v-text="processing ? $t('Message.loading') : $t('CustomersCardEdit.createSegment')"
              />
            </div>
          </b-col>
        </b-row>
      </b-col>
    </ValidationObserver>
    <Modal
        id="modal-access-denied"
        :hideFooter="true"
        :no-close-on-backdrop="true"
        :hide-header="true"
        :hide-back-drop="true"
    >
      <access-denied/>
    </Modal>
  </div>
</template>

<script>
import basic from '@/@core/components/editCustomer/basic.vue';
import invoice from '@/@core/components/editCustomer/invoice.vue';
import vSelect from 'vue-select';
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import {getCountries} from './constants/countries'
import useAppConfig from '@core/app-config/useAppConfig';
import {ARTICLE_SEGMENT} from './constants/segment'
import debounce from 'lodash.debounce';
import accessDenied from "@core/components/permission/accessDenied";
import {mapGetters} from "vuex";

export default {
  name: 'CreateArticleSegment',
  components: {
    basic,
    invoice,
    ValidationObserver,
    ValidationProvider,
    vSelect, accessDenied
  },
  data() {
    return {
      config: useAppConfig(),
      tabSwitch: 1,
      singleSegment: {...ARTICLE_SEGMENT},
      sendingModalAction: false,
      processing: false,
      countries: [...getCountries()],
      currentComponent: 'basic',
      tabs: [
        {
          label: 'CustomersCardEdit.basic',
          component: 'basic',
          active: true,
        },
        {
          label: 'CustomersCardEdit.invoice',
          component: 'invoice',
          active: false,
        },
      ],
      locale: {
        back: "articleSectionCard.backOverview",
        tabs: 'CustomersCard',

        delete: 'CustomersCardEdit.dltBtn',
        cancel: 'CustomersCardEdit.cancel',
        details: 'InvoiceCardCustomerEdit.details',

        averageMonthly: "ArticleSegment.form.averageMonthly",
        manufacturer: "ArticleSegment.form.manufacturer",
        supplier: "ArticleSegment.form.supplier",
        inventoryLocation: "ArticleSegment.form.inventoryLocation",
        unit: "ArticleSegment.form.unit",
        discontinue: "ArticleSegment.form.discontinue",
        stockItem: "ArticleSegment.form.stockItem",
        externalWebshop: "ArticleSegment.form.externalWebshop",
        productType: "ArticleSegment.form.productType",
        stock: "ArticleSegment.form.stock",
        service: "ArticleSegment.form.service",
        name: "CustomerSegment.name",
        description: "CustomerSegment.description",
        notes: "CustomerSegment.notes",
        purchaseAccount: "ArticleSegment.form.purchaseAccount",
        createSegment: "ArticleSegment.createSegment",


      },
      waysOfDelivery: [],
      deliveryTerms: [],
      termsOfPayment: [],
      printTemplates: [],
      priceLists: [],
      currencies: [],
      costCenter: [],
      projects: [],
      accountResults: [],
      printTemplateInvoice: [],
      printTemplateOffer: [],
      printTemplateOrder: [],
      printTemplateCashInvoice: [],
      units: [],
      suppliers: [],
    };
  },
  computed: {
    message() {
      return this.GET_LOCALE === 'sv' ? 'message' : 'eng_message'
    },
    features() {
      if (this.getLang == '') {
        return this.swedishLang ? 'features' : 'features';
      } else return this.getLang == 'sv' ? 'features' : 'features';
    },
    getLang() {
      return this.config.lang.value;
    },
    ...mapGetters({
      GET_LOCALE: 'appConfig/getLocale'
    })
  },
  methods: {
    switchTabs(tabIndex) {
      this.tabs.find(item => item.active == true).active = false;

      this.currentComponent = this.tabs[tabIndex].component;
      this.tabSwitch = this.tabs[tabIndex].component === 'invoice' ? 2 : 1

      this.tabs[tabIndex].active = true;
    },
    async getAllRegisters() {
      const units = await this.$useJwt.getAllRegisters('units')
      const {data} = await this.$useJwt.getSuppliers()
      this.units = units.data.results.map(el => {
        return {label: el.description, value: el.code}
      })
      this.suppliers = data.results.map(el => {
        return {label: el.name, value: el.name}
      })
    },
    searchAccounts(search, loading) {
      if (search.length) {
        loading(true);
        this.searchRemoteAccounts(loading, search, this);
      }
    },
    searchRemoteAccounts: debounce(function (loading, search, vm) {
      this.$useJwt.getAllRegisters(`accounts?search=${escape(search)}`)
          .then(res => {
            this.accountResults = res.data.results
            loading(false);
          })
          .catch(err => {
          })
    }, 350),
    changeAccounts(account, key) {
      this.singleSegment[key] = account.number
    },
    createArticleSegment() {
      this.$refs.segmentForm.validate().then(res => {
        if (res) {
          this.processing = true
          const payload = this.singleSegment
          this.$useJwt.customSegment({URL: '/articles', method: 'post'}, payload)
              .then(res => {
                this.processing = false
                this.$router.push({
                  name: 'acountingArticleSegmentEdit',
                  params: {id: res.data.uuid},
                  query: {redirect: true}
                })
                this.popupMsg(
                    this.$t('Message.Success'),
                    res.data[this.message],
                    'CheckIcon',
                    'success'
                );
              })
              .catch(err => {
                this.processing = false
                if (err.response.data && err.response.data && err.response.data.message) {
                  if (err.response.data.message.ErrorInformation) {
                    this.popupMsg(
                        this.$t('Message.Failed'),
                        err.response.data.message.ErrorInformation.message,
                        'AlertTriangleIcon',
                        'danger'
                    );
                  } else {
                    this.popupMsg(
                        this.$t('Message.Failed'),
                        err.response.data.message,
                        'AlertTriangleIcon',
                        'danger'
                    );
                  }
                } else {
                  this.popupMsg(
                      this.$t('Message.Failed'),
                      err.response.data[this.message],
                      'AlertTriangleIcon',
                      'danger'
                  );
                }
                if (err.response.status === 403) {
                  window.Bus.$emit('trigger-access-denied', {'data': err.response.data})
                }
              })
        }
      });
    },
    computeSelect(event, key) {
      this.singleSegment[key] = event.value
    },
    openAccessDeniedModal() {
      this.$store.commit('appConfig/UPDATE_ACCESS_DENIED', true)
      this.$bvModal.show("modal-access-denied");

    },
  },

  mounted() {
    this.getAllRegisters()
  },
};
</script>

<style lang='scss'>
@import '@core/scss/vue/libs/vue-select.scss';

</style>
